export default __webpack_public_path__ + "static/media/gmailIcon.83c8cb09.svg";